module.exports = __webpack_public_path__ + "img/employee.97269d1e.svg";